export default "__VITE_ASSET__92629a39__"